var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fe-html",domProps:{"innerHTML":_vm._s(_vm.fq.fq_info)}})}
var staticRenderFns = []

export { render, staticRenderFns }